import { AuthContextInterface, useModal } from "@surveying-hub-bv/fe-component-library"
import { ReactNode, useMemo } from "react"
import { copyRight, topLogo } from "./Copy"
import { ExtendedAuthContextInterface } from "../AuthProvider"
import { LoginFormDialog } from "./Routing"
import { InjectableProps, Layout as NewLayout } from "./layout-components/Layout"
import { NavItem, notLoggedInNavigation as newNotLoggedInNavigation, adminNavigation as newAdminNavigation, userNavigation as newUserNavigation } from "./layout-components/NavigationMap"
import { useTranslation } from "react-i18next"



export const LoggedOutLayout = ({ main, callBack, pageName }: InjectableProps) => {
    const { t } = useTranslation()
    const nav = useMemo(() => newNotLoggedInNavigation(t), [t])

    return <MainLayout main={main} callBack={callBack} pageName={pageName} navigation={nav} selector={<></>} />
}

export const UserLayout = (selector: ReactNode, loggedIn: ExtendedAuthContextInterface) => {
    const { t } = useTranslation()
    const nav = useMemo(() => [...newNotLoggedInNavigation(t), ...newUserNavigation(t)], [t])
    return ({ main, callBack, pageName }: InjectableProps) => {
        return <MainLayout main={main} callBack={callBack} loggedIn={loggedIn} pageName={pageName} navigation={nav} selector={selector} />
    }
}

// TODO: Commenting out as we are not using these layouts.
// export const OrganizationMemberLayout = (organization: string, selector: ReactNode, loggedIn: ExtendedAuthContextInterface) => ({ main, callBack, pageName }: InjectableProps) =>
//     <MainLayout main={main} callBack={callBack} loggedIn={loggedIn} pageName={pageName} navigation={organizationMemberNavigation(organization)} selector={selector} />

// export const OrganizationAdminLayout = (organization: string, selector: ReactNode, loggedIn: ExtendedAuthContextInterface) => ({ main, callBack, pageName }: InjectableProps) =>
//     <MainLayout main={main} callBack={callBack} loggedIn={loggedIn} pageName={pageName} navigation={organizationAdminNavigation(organization)} selector={selector} />

export const AdminLayout = (selector: ReactNode, loggedIn: ExtendedAuthContextInterface) => {
    const { t } = useTranslation()
    const nav = useMemo(() => [...newAdminNavigation(t)], [t])
    return ({ main, callBack, pageName }: InjectableProps) => {
        return <MainLayout main={main} callBack={callBack} loggedIn={loggedIn} pageName={pageName} navigation={nav} selector={selector} profileType="Admin" />
    }
}

// Skylar's New Layout
const MainLayout = ({ main, callBack, loggedIn, pageName, navigation, selector, profileType }: InjectableProps & { navigation: NavItem[], selector: ReactNode, profileType?: string, loggedIn?: ExtendedAuthContextInterface & AuthContextInterface }) => {
    const { showModal } = useModal()
    return <NewLayout main={main} callBack={callBack} loggedIn={loggedIn} pageName={pageName} topLogo={topLogo} copyRight={copyRight}
        selector={selector ? [selector] : undefined} navigation={navigation} accountPageUrl={"/settings"} loginUrl={() => showModal(<LoginFormDialog />)} profileType={profileType} />
}
